module.exports = __webpack_public_path__ + "1792395595471/images/brandbook-half-o-bottom.16281ed.svg";